import { useNavigate } from 'react-router-dom';
import { useMemo } from 'react';
import { getChestIcon } from '../../../../Components/utils/getChestIcon';
import { formatNumbers } from '../../../../helpers';
import StarIcon from '../../../../icons/Star';
import Pages from '../../../../Router/pages';
import { useAppDispatch, useAppSelector } from '../../../../store';
import { setActiveChest } from '../../../../store/reducers/chests';
import { TChestResponse } from '../../../../types';

function ChestsList() {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { chestsList } = useAppSelector(({ chests }) => chests);

  const onClick = (chest: TChestResponse) => {
    dispatch(setActiveChest(chest));

    navigate(Pages.chest(chest.id.toString()));
  };
  const chestOrder = ['launch', 'orbit', 'galaxy', 'supernova'];

  const sortedChests = useMemo(() => [...chestsList].sort((a, b) => chestOrder.indexOf(a.variant) - chestOrder.indexOf(b.variant)), [chestOrder, chestsList]);
  return (
    <div
      className="grid grid-cols-[repeat(auto-fill,_minmax(167px,_1fr))] gap-2"
    >
      {/* tutorial chest created only for tutorial and should look like launch */}
      {sortedChests.filter((chest) => chest.variant !== 'tutorial').map((ch) => (
        <div
          key={ch.id}
          className={`
            relative
            aspect-[0.835/1]
            px-[10px] py-2
            bg-${ch.variant}ChestCardBg
            gradient-border cyan z-[1] before:rounded-[12px]
            rounded-[12px]
            overflow-hidden
          `}
          onClick={() => onClick(ch)}
        >
          <div
            className="
                relative
                font-Bangers
                flex items-center justify-between
                z-[2]
            "
          >
            <span>
              {ch.variant}
              {' '}
              chest
            </span>
            <div className="flex items-center">
              <StarIcon size={24} />
              <span className="text-sm">{formatNumbers(ch.price)}</span>
            </div>
          </div>
          {getChestIcon(ch.variant, {
            glow: true,
            shine: true,
            classNames: {
              glow: { wrapper: 'absolute  inset-0 scale-[1.5]' },
              chest: { icon: 'max-h-[180px]' },
            },
          })}
        </div>
      ))}
    </div>
  );
}

export default ChestsList;
